import { IParamsToSend } from '@base/@types/providers/Alert/PurchaseProvider'

export const purchaceRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: false
  },

  curvaABC: {
    descricoes: [],
    agrupar: false
  },
  fornecedor: {
    ids: [],
    agrupar: false
  },
  subCategoria: {
    ids: [],
    agrupar: true
  }
}
